<div class="ads ads-970" *ngIf="mode === googleAds.Ads970">
  <!--  <div id='div-gpt-ad-1606730682358-0' #showBigTopEl class="wrapper">-->
  <div id='{{topBig}}' #showBigTopEl class="wrapper">
  </div>
</div>
<div class="ads ads-300-100 mobile-ads" *ngIf="mode === googleAds.Ads970">
  <!--  <div id='div-gpt-ad-1606805762044-0' #showSmallTopEl class="wrapper">-->
  <div id='{{topSmall}}' #showSmallTopEl class="wrapper">
  </div>
</div>
<div class="ads ads-300" *ngIf="mode === googleAds.Ads300">
  <!--  <div id='div-gpt-ad-1606808310162-0' #showBottomEl class="wrapper">-->
  <div id='{{bottom}}' #showBottomEl class="wrapper">
  </div>
</div>
